import React from 'react';

const BlogEntry = ({ title, entry, date }) => {
  const formatted = date
    ? new Date(date + 'T00:00:00').toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : '';

  return (
    <div className="blog-entry mt-3">
      {formatted && <p className="blog-date">{formatted}</p>}
      <h3>{title}</h3>
      <p>{entry}</p>
    </div>
  );
};

export default BlogEntry;
